import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildSharedToursUrl = (sessionKey, endpoint) =>
  `${API_ROUTES.SHARED_TOURS.BASE}/${sessionKey}/${endpoint ? endpoint : ""}`

export const sharedToursApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    requestConsultation: builder.mutation({
      query: ({ sessionKey, lead }) => ({
        url: buildSharedToursUrl(sessionKey, API_ROUTES.SHARED_TOURS.REQUEST_CONSULTATION),
        method: "POST",
        body: { lead },
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useRequestConsultationMutation } = sharedToursApi
